import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { List } from 'immutable';
import {
  getCountry,
  getCurrentLocale,
  getDefaultLanguage,
  getSupportedLanguages,
  isLoaded,
  isLoading,
} from '../reducers';
import { ILocaleLanguage } from 'i2g-ng-utils';

@Injectable()
export class LocalizationStore {
  constructor(private _store: Store<any>) {}

  isLoading(): Observable<boolean> {
    return this._store.pipe(select(isLoading));
  }

  isLoaded(): Observable<boolean> {
    return this._store.pipe(select(isLoaded));
  }

  getCurrentLocale(): Observable<string> {
    return this._store.pipe(select(getCurrentLocale));
  }

  getCountry(): Observable<string> {
    return this._store.pipe(select(getCountry));
  }

  getDefaultLanguage(): Observable<string> {
    return this._store.pipe(select(getDefaultLanguage));
  }

  getSupportedLanguages(): Observable<List<ILocaleLanguage>> {
    return this._store.pipe(select(getSupportedLanguages));
  }
}
